import all from './all';
import items from './items';
import destroy from './destroy';
import bulkCancel from './bulkCancel';
import store from './store';
import show from './show';
import update from './update';
import confirm from './confirm';
import bulkConfirm from './bulkConfirm';
import confirmShipping from './confirmShipping';
import bulkConfirmShipping from './bulkConfirmShipping';
import bulkConfirmAndShipping from './bulkConfirmAndShipping';
import events from './events';
import confirmAsOrdered from './confirmAsOrdered';
import search from './search';
import simpleOrder from './simpleOrder';
import counts from './counts';
import getNextPreviousId from './getNextPreviousId';
import clientSetting from './clientSetting';
import returnOrder from './returnOrder';
import completeReturnOrder from './completeReturnOrder';
import downloadShippingLabel from './downloadShippingLabel';
import downloadPalletLabel from './downloadPalletLabel';

export default {
  all,
  items,
  destroy,
  bulkCancel,
  store,
  show,
  update,
  confirm,
  bulkConfirm,
  confirmShipping,
  bulkConfirmShipping,
  bulkConfirmAndShipping,
  events,
  confirmAsOrdered,
  search,
  simpleOrder,
  counts,
  getNextPreviousId,
  clientSetting,
  returnOrder,
  completeReturnOrder,
  downloadShippingLabel,
  downloadPalletLabel,
};



// WEBPACK FOOTER //
// ./src/app/services/order/index.js